<template>
    <div>
        <div class="content-course-box__add-materials" v-if="materials.videoData.video">
            <VideoPlayer :videoData="materials.videoData" :show-key="1" />
        </div>
        <DescriptionComponent v-if="materials.description" :description="materials.description" @emitData="emitData" />
        <!--        <div class="content-course-box__add-materials " v-if="materials.resources.length">-->
        <!--            <p>Файлы</p>-->
        <!--            <div class="sticks">-->
        <!--                <div class="stick" v-for="(name, index) of materials.resources" :key="index">-->
        <!--                    <Stick :config="{ name, index, actionFunc: removeResource }" />-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
import Stick from "../../../course-module/course-creating/components/Stick";
import VideoPlayer from "../../../course-module/course-creating/components/VideoPlayer";
import DescriptionComponent from "./DescriptionComponent";
import { mapMutations } from "vuex";

export default {
    name: "MaterialFilledComponent",
    props: ["materials", "fillerId", "config"],
    components: {
        Stick,
        VideoPlayer,
        DescriptionComponent
    },
    methods: {
        emitData(data) {
            this.$emit("emitData", data);
        },
        removeResource(idx) {
            // this[LEARNING_LECTURE_RESOURCE_REMOVE]({
            //     chapterId: this.$route.params.chapterId,
            //     lectureId: this.fillerId,
            //     idx
            // });
        }
    }
};
</script>

<style lang="scss" scoped>
.sticks {
    width: 320px;

    .stick {
        margin-bottom: 10px;
    }
}
</style>
